













import * as Util from '@/util.ts';
import Vue from 'vue';

export default Vue.extend({
  computed: {
    currBrowser() {
      const ua: string = navigator.userAgent.toLowerCase();
      if (ua.includes('ppera') || ua.includes('opr')) {
        return 'unknown';
      } else if (ua.includes('chrome')) {
        return 'chrome';
      } else if (ua.includes('safari') && !ua.includes('chrome')) {
        return 'safari';
      } else if (ua.includes('firefox')) {
        return 'firefox';
      } else if (ua.includes('edge')) {
        return 'edge';
      }
      return 'unknown';
    },
  },
  mounted() {
    Util.onShowPWAPrompt();
  },
});
